module.exports = __webpack_public_path__ + "static/img/keywords-chart.6fd71aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/keywords-chart.png
// module id = 0slV
// module chunks = 1